<template>
  <div class="oa-container">
    <div class="container-title">
      <div class="title-text1">PLATFORM</div>
      <div class="title-text2">培训学习平台</div>
      <div class="title-blueline"></div>
      <div class="title-text3">助力员工学习企业文化，培训员工专业知识与技能，提升员工专业性与企业归属感</div>
    </div>
    <div class="section-content">
      <ul class="content-list">
        <li class="list-item">
          <div class="item-topline"></div>
          <div class="item-img"><img src="../../../../assets/digitalize_imgages/16.png" alt=""></div>
          <div class="item-header">体系化</div>
          <div class="item-content">体系化培训管理，培训学习考试评分归档全程留痕可追溯，保障培训效果。</div>
          <div class="item-bottomline"></div>
        </li>
        <li class="list-item">
          <div class="item-topline"></div>
          <div class="item-img"><img src="../../../../assets/digitalize_imgages/17.png" alt=""></div>
          <div class="item-header">在线化</div>
          <div class="item-content">融在线课堂、在线直播、在线考试管理等多项功能于一体，培训全过程在线进行。</div>
          <div class="item-bottomline"></div>
        </li>
        <li class="list-item">
          <div class="item-topline"></div>
          <div class="item-img"><img src="../../../../assets/digitalize_imgages/18.png" alt=""></div>
          <div class="item-header">移动化</div>
          <div class="item-content">学员可利用手机随时随地学习、考试，充分利用碎片化时间学习成长。</div>
          <div class="item-bottomline"></div>
        </li>
        <li class="list-item">
          <div class="item-topline"></div>
          <div class="item-img"><img src="../../../../assets/digitalize_imgages/19.png" alt=""></div>
          <div class="item-header">业务化</div>
          <div class="item-content">从理论化学习转向实践导向的培训，强调对业务体系快速支撑。</div>
          <div class="item-bottomline"></div>
        </li>
        <li class="list-item">
          <div class="item-topline"></div>
          <div class="item-img"><img src="../../../../assets/digitalize_imgages/20.png" alt=""></div>
          <div class="item-header">游戏化</div>
          <div class="item-content">通过问答竞赛、闯关学习，辅以闯关证书、积分悬赏等激励形式,增强学习乐趣。</div>
          <div class="item-bottomline"></div>
        </li>
        <li class="list-item">
          <div class="item-topline"></div>
          <div class="item-img"><img src="../../../../assets/digitalize_imgages/21.png" alt=""></div>
          <div class="item-header">个性化</div>
          <div class="item-content">根据研发、销售等不同岗位个性化制定学习地图。</div>
          <div class="item-bottomline"></div>
        </li>
      </ul>
    </div>
    <div class="crumbs-nav">
      <svg t="1647833705034" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="3680" width="0.2rem" height="0.2rem"><path d="M938.412716 480.847489 556.823881 104.126522c-1.89721-2.258437-6.142907-6.194072-12.037151-10.081613-9.920954-6.544043-21.162995-10.520611-33.496905-10.520611-13.180184 0-24.690332 3.997034-34.357506 10.623965-5.846148 4.010337-9.876951 8.102538-12.157901 11.154038L84.209914 480.894561c-14.700817 14.481829-14.700817 38.014802 0 52.529377 14.585183 14.427594 33.995255 8.343015 50.529837-7.945973l25.607214-25.314549 38.918381-37.700647c-1.359974 1.686409-2.282996 2.963495-2.284019 3.373841L196.981327 847.484797c0 50.006927 40.941458 90.427522 91.442642 90.427522l141.713582 0 10.423397 0L440.560948 927.486876 440.560948 686.440961c0-17.467837 14.411221-31.683607 32.223912-31.683607l77.051887 0c17.814738 0 32.223912 14.21577 32.223912 31.683607L582.060659 927.486876l0 10.425444 10.425444 0 141.713582 0c50.485835 0 91.442642-40.428781 91.442642-90.427522L825.642327 467.251843l62.246693 61.207014c20.142759 13.266142 37.897122 17.434068 50.523697 4.963035C953.114556 518.910387 953.114556 495.361041 938.412716 480.847489z" p-id="3681" fill="#c6c6c6"></path></svg>
      <div class="crumbs-text1"  @click="goToHome">首页</div>
      <div class="crumbs-text2">产品服务</div>
      <div class="crumbs-text3" @click="goToDigitalize">政企数字化</div>
      <div class="crumbs-text4">培训学习平台</div>
      <img src="../../../../assets/images/路径 93.png" alt="" class="crumbs-img1" @click="goToHome">
      <img src="../../../../assets/images/路径 94.png" alt="" class="crumbs-img2">
      <img src="../../../../assets/images/路径 95(1).png" alt="" class="crumbs-img3" @click="goToDigitalize">
      <img src="../../../../assets/images/路径 96.png" alt="" class="crumbs-img4">
    </div>
    <Footer></Footer>
  </div>
</template>

<script>
import Footer from "@/componets/footer/Footer"
export default {
  components: {
    Footer
  },
  methods: {
    goToHome() {
      this.$router.push("/home")
    },
    goToDigitalize() {
      this.$router.back()
    }
  },
}
</script>

<style lang="less" scoped>
.oa-container {
  width: 19.2rem;
  font-size: 0.22rem;
  margin-top: 0.88rem;
  font-family: Source Han Sans CN;
  font-weight: 400;
  position: relative;
}
.title-text1 {
  font-family: DIN;
  line-height: 0.27rem;
  color: #ADADAD;
}
.title-text2 {
  font-size: 0.38rem;
  line-height: 0.56rem;
  margin-top: 0.1rem;
  color: #333333;
}
.title-blueline {
  width: 0.5rem;
  height: 0.04rem;
  margin-left: 9.35rem;
  margin-top: 0.2rem;
  background-color: #0078FF;
}
.title-text3 {
  line-height: 0.5rem;
  margin-top: 0.5rem;
  color: #666666;
}
.section-content {
  width: 12.9rem;
  height: 4.9rem;
  margin-left: 3rem;
  margin-bottom: 0.6rem;
}
.section-content img {
  width: 0.7rem;
  height: 0.7rem;
}
.content-list {
  list-style: none;
}
.list-item {
  width: 3.8rem;
  height: 1.7rem;
  float: left;
  margin: 0.4rem 0.15rem;
  border: 0.01rem solid #E2E2E2;
  position: relative;
}
.item-topline {
  width: 0rem;
  height: 0.02rem;
  background-color: #0078FF;
  position: absolute;
  transform: translate(-50%);
  left: 50%;
}
.item-img {
  width: 0.7rem;
  height: 0.7rem;
  position: absolute;
  top: -0.35rem;
  left: 1.55rem;
}
.item-header {
  font-weight: 500;
  line-height: 0.33rem;
  margin-top: 0.47rem;
  color: #666666;
}
.item-content {
  width: 3rem;
  height: 0.48rem;
  text-align: left;
  font-size: 0.16rem;
  line-height: 0.24rem;
  margin-top: 0.2rem;
  margin-left: 0.4rem;
  overflow: hidden;
  color: #666666;
}
.item-bottomline {
  width: 0.7rem;
  height: 0.02rem;
  background-color: #0078FF;
  position: absolute;
  top: 1.7rem;
  left: 1.55rem;
}
//动画效果 向上
li:hover .item-header {
  animation: slide-top 0.5s cubic-bezier(0.250, 0.460, 0.450, 0.940);
  animation-fill-mode:forwards; 
}
li:hover .item-content{
  animation: slide-top 0.5s cubic-bezier(0.250, 0.460, 0.450, 0.940);
  animation-fill-mode:forwards; 
  overflow: visible;
}
@keyframes slide-top {
  0% {
    -webkit-transform: translateY(0);
            transform: translateY(0);
  }
  100% {
    -webkit-transform: translateY(-0.35rem);
            transform: translateY(-0.35rem);
  }
}
//消失
li:hover .item-img {
  animation: scale-out-center 0.5s cubic-bezier(0.550, 0.085, 0.680, 0.530);
  animation-fill-mode:forwards; 
}
li:hover .item-bottomline {
  animation: scale-out-center 0.5s cubic-bezier(0.550, 0.085, 0.680, 0.530);
  animation-fill-mode:forwards; 
}
@keyframes scale-out-center {
  0% {
    -webkit-transform: scale(1);
            transform: scale(1);
    opacity: 1;
  }
  100% {
    -webkit-transform: scale(0);
            transform: scale(0);
    opacity: 0;
  }
}
//出现
li:hover .item-topline {
  animation: show-line 0.5s cubic-bezier(0.550, 0.085, 0.680, 0.530);
  animation-fill-mode:forwards; 
}
 @keyframes show-line {
            0% {
              width: 0rem;
            }
            100% {
               width: 2.8rem;
            }
 }
//蓝色的面包屑导航
.crumbs-nav {
  width: 8rem;
  height: 0.6rem;
  font-size: 0.16rem;
  position: relative;
  position: absolute;
  top: -1.18rem;
  left: 2.6rem;
}
.crumbs-nav img {
  cursor: pointer;
}
.icon {
  position: absolute;
  top: 0.18rem;
  left: 0.41rem;
  z-index: 99;
}
.crumbs-text1 {
  cursor: pointer;
  position: absolute;
  top: 0.18rem;
  left: 0.73rem;
  color: #C6C6C6 ;
  z-index: 99;
}
.crumbs-text2 {
  cursor: pointer;
  position: absolute;
  top: 0.18rem;
  left: 1.73rem;
  color: #C6C6C6 ;
  z-index: 99;
}
.crumbs-text3 {
  cursor: pointer;
  position: absolute;
  top: 0.18rem;
  left: 3rem;
  color: #C6C6C6 ;
  z-index: 99;
}
.crumbs-text4 {
  cursor: pointer;
  position: absolute;
  top: 0.18rem;
  left: 4.65rem;
  color: #FFFFFF;
  z-index: 99;
}
.crumbs-img1 {
  width: 1.45rem;
  height: 0.6rem;
  position: absolute;
  left: 0;
  z-index: 3;
}
.crumbs-img2 {
  width: 2.04rem;
  height: 0.6rem;
  position: absolute;
  left: 0.72rem;
  z-index: 2;
}
.crumbs-img3 {
  width: 2.07rem;
  height: 0.6rem;
  position: absolute;
  left: 2.17rem;
  z-index: 1
}
.crumbs-img4 {
  width: 2.62rem;
  height: 0.6rem;
  position: absolute;
  left: 3.7rem;
}
</style>